import React from "react"

const TextItem = ({title, value, align="left"}) => (
  <div style={{padding:'0 0.5rem', display:"flex", flexDirection:"column"}}>
    <div style={{fontSize:10, lineHeight:'0.75rem'}}>{title}</div>
    <div style={{fontSize:14, alignSelf:align}}>{value}</div>
  </div>
)

export default TextItem